import { reactive } from 'vue';

export const criarManifTipo = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdtipo: 0,
        nmtipo: '',
        detalhamento: '',
        ativo: 'S',
        idlogin: 0
    });
};